import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the Invoicing menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  ldFlags: object
 *  order?: number
 *  entitlements: Set<string>
 * }} params
 * @returns {object}
 */
export function getInvoicingMenu({
  businessEntityUuid, ldFlags, order, entitlements
}) {
  const { releaseStandaloneInvoicing } = ldFlags;
  const hasMoneyPro = entitlements.has('money_pro');
  const hasBanking = entitlements.has('banking');

  if (!releaseStandaloneInvoicing || !hasBanking || hasMoneyPro) {
    return {};
  }

  return processMenu({
    title: 'Invoices',
    itemId: 'invoices',
    icon: 'receipt-list-fill.svg',
    path: generatePath(ROUTES.entityInvoicing, { businessEntityUuid }),
    order
  });
}
